<template>
    <div class="flex flex-wrap items-center justify-center">
        <div class="absolute top-4 sm:top-8 right-8">
            <a class="font-bold text-teal" href="#" @click="changeLocale('en')">ENG</a>
            <span class="inline-block font-bold text-teal mx-2">|</span>
            <a class="font-bold text-teal" href="#" @click="changeLocale('it')">ITA</a>
        </div>
        <div class="w-full lg:w-5/12 px-6 text-center py-6 lg:pb-16 bg-white flex flex-wrap items-center">
            <form class="w-full px-6 xl:px-20 2xl:px-32 text-left mt-4">
                <router-link to="/"><img src="@/assets/images/logo.png" class="h-10 w-auto h-auto max-h-10 mx-auto"></router-link>

                <h1 class="uppercase text-xl sm:text-2xl mt-6 font-extrabold max-w-sm text-center mx-auto">{{ $t("concorso di idee") }}</h1>
                <h2 class="text-sm sm:text-base font-semibold text-center">'Il Chilometro verde'</h2>

                <label class="block text-green-dark font-medium mt-12">{{ $t("Name") }}</label>
                <input v-model="name" type="text" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.name.$error}">
                <span v-if="$v.name.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>
                
                <label class="block text-green-dark font-medium mt-4">{{ $t("Surname") }}</label>
                <input v-model="surname" type="text" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.surname.$error}">
                <span v-if="$v.surname.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>

                <label class="block text-green-dark font-medium mt-4">{{ $t("Email") }}</label>
                <input v-model="email" type="email" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.email.$error}">
                <div v-if="$v.email.$error" class="block text-red-500 text-xs ml-4">
                    <div v-if="!$v.email.required">{{ $t("Required field") }}</div>
                    <div v-if="!$v.email.email">{{ $t('Email address not valid') }}</div>
                </div>

                <label class="block text-green-dark font-medium mt-4">{{ $t("Numero di matricola universitaria") }}</label>
                <input v-model="badge" type="text" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.badge.$error}">
                <span v-if="$v.badge.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>

                <label class="block text-green-dark font-medium mt-4">{{ $t("New Password") }}</label>
                <input v-model="password" type="password" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.password.$error}">
                <div v-if="$v.password.$error" class="block text-red-500 text-xs ml-4">
                    <div v-if="!$v.password.required">{{ $t("Required field") }}</div>
                    <div v-if="!$v.password.minLength">{{ $t('Password must be at least 6 characters length') }}</div>
                </div>

                <label class="block text-green-dark font-medium mt-4">{{ $t("Password Confirmation") }}</label>
                <input v-model="passwordConfirmation" type="password" class="w-full block border border-gray-dark rounded-full bg-gray-light py-2 px-4 mt-1 focus:outline-none" :class="{'border border-red-500': $v.passwordConfirmation.$error}">
                <div v-if="$v.passwordConfirmation.$error" class="block text-red-500 text-xs ml-4">
                    <!-- <div v-if="!$v.passwordConfirmation.required">{{ $t("Required field") }}</div> -->
                    <div v-if="!$v.passwordConfirmation.sameAsPassword">{{ $t('Passwords do not match') }}</div>
                </div>

                <label class="block text-green-dark mt-6" for="age">
                    <input type="checkbox" v-model="age" class="mr-1" id="age">{{ $t('age') }}
                </label>
                <span v-if="$v.age.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>

                <label class="block text-green-dark mt-4" for="tos">
                    <input type="checkbox" v-model="tos" class="mr-1" id="tos">
                    <i18n path="term" tag="label" for="tos">
                        <router-link to="/privacy-policy" class="font-bold underline" target="_blank">{{ $t('tos') }}</router-link>
                    </i18n>
                </label>
                <span v-if="$v.tos.$error" class="block text-red-500 text-xs ml-4">{{ $t("Required field") }}</span>

                <button @click.prevent="register" class="relative font-medium bg-green-light text-white px-12 py-2 rounded-full mt-6 block w-full focus:outline-none" :disabled="loading">{{ $t("Register") }}
                    <loaderIco class="h-5 w-5 text-white" v-if="loading" />
                </button>
                <div v-if="error" class="bg-red-400 text-white text-center shadow-sm rounded-lg font-bold p-4 mt-4">{{ error }}</div>
            </form>
            <div class="mt-16 lg:mt-16 text-center px-6 pb-4 w-full">
                {{ $t("Already have an account?") }}
                <router-link to="/login" class="text-orange font-bold underline">{{ $t("Go to Login") }}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'    
import loaderIco from '@/svg/loader.vue'
import firebase from 'firebase/app'
import { db } from '@/db'
import "@firebase/auth";

export default {
    components: { loaderIco },
    data() {
        return {
            name: '',
            surname: '',
            email: '',
            badge: '',
            password: '',
            passwordConfirmation: '',
            age: null,
            tos: null,
            loading: false,
            error: null
        }
    },
    mounted() {
        this.$v.$reset()
    },
    validations: {
        name: {
            required,
        },
        surname: {
            required,
        },
        email: {
            required,
            email
        },
        badge: {
            required,
        },
        password: {
            required,
            minLength: minLength(6)
        },
        passwordConfirmation: {
            required,
            sameAsPassword: sameAs('password')
        },
        age: {
            sameAs: sameAs( () => true ) 
        },
        tos: {
            sameAs: sameAs( () => true ) 
        }
    },
    methods: {
        register() {
            this.$v.$touch()
            if (this.$v.$invalid) return false

            this.loading = true
            firebase
                .auth()
                .createUserWithEmailAndPassword(this.email, this.password)
                .then(userCredential => {       
                    let user = {
                        uid: userCredential.user.uid,
                        name: this.name,
                        surname: this.surname,
                        email: this.email,
                        badge: this.badge
                    }                                      
                    // persist user
                    db.collection('users').add(user).then(docRef => {
                        user.id = docRef.id
                        // store user locally
                        this.$store.commit('SET_USER', user)
                        
                        this.$router.push('dashboard')
                        this.loading = false
                    })                    
                })
                .catch(error => {
                    this.loading = false
                    switch(error.code) {
                        case 'auth/email-already-in-use': 
                            this.error = this.$t('The email address is already in use by another account')
                        break;
                        default:
                            this.error = this.$t('A network error as occured, try again in a few seconds')
                    }      
                })
        }
    },
}
</script>